(function () {
  if (window.__ccCollectionAtcBound) return;
  window.__ccCollectionAtcBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cc-atc[data-variant-id]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled || button.classList.contains('is-loading')) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    function reset() {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }

    function showError(error) {
      console.error(error);
      button.classList.add('is-error');
      button.setAttribute('aria-label', error.message || window.cartStrings.error);
      setTimeout(function () {
        button.classList.remove('is-error');
      }, 3000);
    }

    function fallbackAdd() {
      return fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || window.cartStrings.error);
            }
            return data;
          });
        })
        .then(function () {
          if (typeof window.upcartRefreshCart === 'function') {
            try {
              window.upcartRefreshCart();
            } catch (error) {}
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var upcartHost = document.getElementById('upCart');
          if (!upcartHost || !upcartHost.shadowRoot) window.location.assign(window.routes.cart_url);
        })
        .catch(showError)
        .finally(reset);
    }

    if (typeof window.addToCartEssentialApps === 'function') {
      try {
        window.addToCartEssentialApps(variantId, 1);
      } catch (error) {
        fallbackAdd();
        return;
      }
      setTimeout(reset, 1500);
    } else {
      fallbackAdd();
    }
  });
})();
